import { Controller } from "@hotwired/stimulus"

// Syncs trial_period_days and toggles the create-confirm modal for gateway vs manual.
export default class extends Controller {
  static targets = [
    "productSelect",
    "trialDaysInput",
    "paymentMethodSelect",
    "subscriberSelect",
    "confirmMessage",
    "gatewayActions",
    "manualActions",
    "confirmModal"
  ]

  static values = {
    trialDaysByProduct: Object,
    emailsBySubscriberRef: { type: Object, default: {} },
    presetEmail: { type: String, default: "" },
    messageTemplate: String
  }

  connect () {
    this.syncTrialDays()
    this.syncPaymentMethodUi()
    this.syncConfirmMessage()
  }

  syncTrialDays () {
    if (!this.hasProductSelectTarget || !this.hasTrialDaysInputTarget) return

    const productId = this.productSelectTarget.value
    if (!productId) return

    const days = this.trialDaysByProductValue[productId]
    if (days === undefined || days === null) return

    this.trialDaysInputTarget.value = days
  }

  syncPaymentMethodUi () {
    const gateway = !this.isManualPaymentMethod()

    if (this.hasGatewayActionsTarget) {
      this.gatewayActionsTarget.classList.toggle("hidden", !gateway)
    }
    if (this.hasManualActionsTarget) {
      this.manualActionsTarget.classList.toggle("hidden", gateway)
    }
    if (this.hasConfirmModalTarget) {
      const modal = this.confirmModalTarget.querySelector("[data-client-modal-target='modal']")
      const interceptSubmit = this.confirmModalTarget.querySelector("[data-form-confirm-modal-target='submit']")
      if (!gateway) {
        modal?.classList.add("hidden")
        if (interceptSubmit) interceptSubmit.disabled = true
      } else if (interceptSubmit) {
        interceptSubmit.disabled = false
      }
    }

    const manualSubmit = this.hasManualActionsTarget
      ? this.manualActionsTarget.querySelector("button[type='submit']")
      : null
    if (manualSubmit) manualSubmit.disabled = gateway
  }

  syncConfirmMessage () {
    if (!this.hasConfirmMessageTarget || !this.hasMessageTemplateValue) return

    const email = this.currentPayerEmail()
    this.confirmMessageTarget.textContent = this.messageTemplateValue.replaceAll("%{email}", email || "…")
  }

  currentPayerEmail () {
    if (this.presetEmailValue) return this.presetEmailValue

    if (!this.hasSubscriberSelectTarget) return ""

    const ref = this.subscriberSelectTarget.value
    if (!ref) return ""

    return this.emailsBySubscriberRefValue[ref] || ""
  }

  isManualPaymentMethod () {
    if (!this.hasPaymentMethodSelectTarget) return false

    return this.paymentMethodSelectTarget.value === "manual"
  }
}
